"use strict";


 /*
 ## External Dependencies ##
 - jQuery ($)
 *
 * ***********************************Example of Usage***********************************
 *
 * 1 - Simple usage
 *    <a ref="trigger">Click HERE</a>
 *    <Popbox isVisible={this.state.popboxVisible} anchor={this.refs.trigger}>
 *      <div>Body</div>
 *    </Popbox>
 *
 * 2 - Execute custom onClose
 *    <a ref="trigger">Click HERE</a>
 *    <Popbox isVisible={this.state.popboxVisible}
 *            anchor={this.refs.trigger}
 *            onClose={this.handleClose}>
 *      <div>Body</div>
 *    </Popbox>
 *
 * 3 - Disabling clickAway onClose
 *    <a ref="trigger">Click HERE</a>
 *    <Popbox isVisible={this.state.popboxVisible}
 *            anchor={this.refs.trigger}
 *            onClose={this.handleClose}
 *            shouldCloseOnClickAway={false}>
 *      <div>Body</div>
 *    </Popbox>
 *
 * 4 - Changing popbox's positions*
 *    <a ref="trigger">Click HERE</a>
 *    <Popbox isVisible={this.state.popboxVisible}
 *            anchor={this.refs.trigger}
 *            verticalPositions={{ anchor: "bottom", target: "top" }}
 *            horizontalPositions={{ anchor: "right" , target: "left" }}
 *            onClose={this.handleClose}>
 *      <div>Body</div>
 *    </Popbox>
 *
 *  *Positioning calulations were based on MaterialUI's Popover solution.
 *   View http://www.material-ui.com/#/components/popover for a live example.
 *
 */

var PureRenderMixin = React.addons.PureRenderMixin;
var cx = require("classnames");
var animation = require("app/util/browser/animation");
var clientRect = require("app/util/browser/client-rect.js");

var Popbox = React.createClass({
  mixins: [PureRenderMixin],
  propTypes: {
    children: React.PropTypes.node.isRequired,
    anchor: React.PropTypes.object.isRequired,
    verticalPositions: React.PropTypes.shape({
      anchor: React.PropTypes.oneOf(["top", "center", "bottom"]),
      target: React.PropTypes.oneOf(["top", "center", "bottom"])
    }),
    horizontalPositions: React.PropTypes.shape({
      anchor: React.PropTypes.oneOf(["left", "middle", "right"]),
      target: React.PropTypes.oneOf(["left", "middle", "right"])
    }),
    shouldCloseOnClickAway: React.PropTypes.bool,
    isVisible: React.PropTypes.bool,
    onClose: React.PropTypes.func,
    isAutoAdjustable: React.PropTypes.bool
  },
  getDefaultProps: function() {
    return {
      isVisible: false,
      isAutoAdjustable: false,
      shouldCloseOnClickAway: true,
      id: "popbox" + Math.ceil(Math.random() * 10000),
      verticalPositions: { anchor: "bottom", target: "top" },
      horizontalPositions: { anchor: "left", target: "left" }
    };
  },
  componentDidUpdate: function() {
    this.handleExternalEvents(this.props.isVisible);
  },
  componentDidMount: function() {
    this.handleExternalEvents(this.props.isVisible);
  },
  componentWillUnmount: function() {
    if (this.props.isVisible) {
      window.removeEventListener("resize", this.handleWindowResize);

      if (this.props.shouldCloseOnClickAway) {
        window.removeEventListener("mouseup", this.handleClickAway);
      }
    }
  },
  handleExternalEvents: function(isVisible) {
    this.windowResizeListener(isVisible);
    this.clickAwayListener(isVisible);
    if (isVisible) {
      this.applyPosition();
    }
  },
  windowResizeListener: function(isVisible) {
    if (isVisible && !this.activeResize) {
      window.addEventListener("resize", this.handleWindowResize);
      this.activeResize = true;
    } else if (this.activeResize) {
      window.removeEventListener("resize", this.handleWindowResize);
    }
  },
  clickAwayListener: function(isVisible) {
    if (this.props.shouldCloseOnClickAway) {
      if (isVisible) {
        window.addEventListener("mouseup", this.handleClickAway);
      } else {
        window.removeEventListener("mouseup", this.handleClickAway);
      }
    }
  },
  handleWindowResize: function() {
    this.timer && clearTimeout(this.timer);
    this.timer = setTimeout(function() {
      this.applyPosition();
      this.timer = null;
    }.bind(this), 100);
  },
  handleClickAway: function(e){
    var $target = $(e.target);

    if ($target.parents("#" + this.props.id).length === 0) {
      this.handleClose();
    }
  },
  handleClose: function() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  },
  applyPosition: function() {
    var calculator = new PositionCalculator(
      {
        vertical: this.props.verticalPositions,
        horizontal: this.props.horizontalPositions,
        isAutoAdjustable: this.props.isAutoAdjustable
      },
      this.props.anchor,
      this.refs.popbox
    );
    var top = calculator.getTop();
    var left = calculator.getLeft();

    this.refs.popbox.style.top = top  + "px";
    this.refs.popbox.style.left = left  + "px";
  },
  render: function() {
    var classes = cx(
      "p-a", "zi-2", {
        "d-n": !this.props.isVisible
      }
    );

    return (
      <div className={classes} id={this.props.id} ref="popbox">
        {this.props.children}
      </div>
    );
  }
});


function PositionCalculator(positions, anchor, target) {
  this.getTop = function getTop() {
    var top = calculateVerticalPlacement(positions.vertical, anchor, target);
    top = adjustVerticalOverflow(top, anchor, target);
    verticalAutoScroll(target);
    return top;
  };
  this.getLeft = function getLeft() {
    var left = calculateHorizontalPlacement(positions.horizontal, anchor, target);
    left = adjustHorizontalOverflow(left, anchor, target);
    horizontalAutoScroll(target);
    return left;
  };

  function calculateVerticalPlacement(positions, anchor, target) {
    var top = anchor.offsetTop;

    if (positions.anchor === "center") {
      top = top + anchor.offsetHeight / 2;
    } else if (positions.anchor === "bottom") {
      top = top + anchor.offsetHeight;
    }

    if (positions.target === "center") {
      top = top - target.offsetHeight / 2;
    } else if (positions.target === "bottom") {
      top = top - target.offsetHeight;
    }

    return top;
  }

  function adjustVerticalOverflow(top, anchor, target) {
    if (positions.isAutoAdjustable) {
      var targetBoundaries = target.getBoundingClientRect();

      var relativeTop = clientRect.getTopRelativeToDocument(target);

      var negativeTopBoundary = (top < 0 && targetBoundaries.top < target.offsetHeight);
      var overflowWindowBottom = (relativeTop + target.offsetHeight > document.body.offsetHeight);

      if (negativeTopBoundary) {
        //Flip down popbox
        top = anchor.offsetTop + anchor.offsetHeight;
      }
      if (overflowWindowBottom) {
        //If Flipping would make it overflow to the top
        if (target.offsetHeight > anchor.offsetTop) {
          //Move popbox up just a little relative to the window
          top = -anchor.offsetTop;
        } else {
          //Flip popbox top position relative to the window
          top = anchor.offsetTop - target.offsetHeight;
        }
      }
    }
    return top;
  }

  function verticalAutoScroll(target) {
    if (!positions.isAutoAdjustable) {
      var targetBoundaries = target.getBoundingClientRect();
      if (targetBoundaries.top + target.offsetHeight > window.innerHeight) {
        animation.autoScrollToShowElement(target, "bottom");
      }
    }
  }

  function calculateHorizontalPlacement(positions, anchor, target) {
    var left = anchor.offsetLeft;

    if (positions.anchor === "middle") {
      left = left + anchor.offsetWidth /2;
    } else if (positions.anchor === "right") {
      left = left + anchor.offsetWidth;
    }

    if (positions.target === "middle") {
      left = left - target.offsetWidth /2;
    } else if (positions.target === "right") {
      left = left - target.offsetWidth;
    }

    return left;
  }

  function adjustHorizontalOverflow (left, anchor, target) {
    if (positions.isAutoAdjustable) {
      var targetBoundaries = target.getBoundingClientRect();

      var relativeLeft = clientRect.getTopRelativeToDocument(target);

      var negativeLeftBoundary = (left < 0 && targetBoundaries.left < target.offsetWidth);
      var overflowWindowRight = (relativeLeft + target.offsetWidth > window.innerWidth);

      if (overflowWindowRight) {
        left = left - (left + target.offsetWidth - window.innerWidth);
      }
      if (negativeLeftBoundary) {
        left = left + (target.offsetWidth - targetBoundaries.left);
      }
    }

    return left;
  }

  function horizontalAutoScroll(target) {
    if (!positions.isAutoAdjustable) {
      var targetBoundaries = target.getBoundingClientRect();
      if (targetBoundaries.left + target.offsetWidth > window.innerWidth) {
        animation.autoScrollToShowElement(target, "bottom");
      }
    }
  }
}

module.exports = Popbox;



// WEBPACK FOOTER //
// ./app/shared/components/Popover/popbox.jsx